/** @file frameNode: selects a node and asks the viewport to frame it (the viewport's frame-selection action). */
import type { EditorStore } from '../../state/editorTypes';
import { frameEvent } from './frameEvent';

/**
 * Makes `name` the selection when it is not part of it, then dispatches `frameEvent` on `target` (default `window`)
 * so the viewport frames the selection. The store has no frame action of its own.
 */
export function frameNode(store: EditorStore, name: string, target: EventTarget = window): void {
  const s = store.getState();
  if (!s.selection.nodes.includes(name)) s.select({ nodes: [name], drawable: null });
  target.dispatchEvent(new CustomEvent(frameEvent, { detail: { node: name } }));
}
